import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import clsx from 'clsx';
import { unstable_composeClasses as composeClasses } from '@mui/utils';
import { useSlotProps } from '@mui/base/utils';
import { styled, useThemeProps } from '@mui/material/styles';
import { PickersActionBar } from '../../../PickersActionBar';
import { getPickersViewLayoutUtilityClass, pickersViewLayoutClasses } from './pickersViewLayoutClasses';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PickersViewLayoutRoot = styled('div', {
  name: 'MuiPickersViewLayout',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'flex',
  flexDirection: 'column'
});
export const PickersViewLayoutContent = styled('div', {
  name: 'MuiPickersViewLayout',
  slot: 'Content',
  overridesResolver: (props, styles) => styles.content
})({
  display: 'flex',
  flexDirection: 'column',
  [`&.${pickersViewLayoutClasses['content--landscape']}`]: {
    flexDirection: 'row'
  }
});
const useUtilityClasses = ownerState => {
  const {
    classes,
    isLandscape
  } = ownerState;
  const slots = {
    root: ['root'],
    content: ['content', isLandscape && 'content--landscape']
  };
  return composeClasses(slots, getPickersViewLayoutUtilityClass, classes);
};
export const PickersViewLayout = /*#__PURE__*/React.forwardRef(function PickersViewLayout(inProps, ref) {
  var _components$ActionBar;
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPickersViewLayout'
  });
  const {
    components,
    componentsProps,
    wrapperVariant,
    children,
    onAccept,
    onClear,
    onCancel,
    onSetToday,
    view,
    views,
    onViewChange,
    value,
    onChange,
    isLandscape,
    disabled,
    readOnly,
    showToolbar,
    className
  } = props;
  const classes = useUtilityClasses(props);
  const ActionBar = (_components$ActionBar = components == null ? void 0 : components.ActionBar) != null ? _components$ActionBar : PickersActionBar;
  const actionBarProps = useSlotProps({
    elementType: ActionBar,
    externalSlotProps: componentsProps == null ? void 0 : componentsProps.actionBar,
    additionalProps: {
      onAccept,
      onClear,
      onCancel,
      onSetToday,
      actions: wrapperVariant === 'desktop' ? [] : ['cancel', 'accept']
    },
    ownerState: _extends({}, props, {
      wrapperVariant
    })
  });
  const Tabs = components == null ? void 0 : components.Tabs;
  const shouldRenderToolbar = showToolbar != null ? showToolbar : wrapperVariant !== 'desktop';
  const Toolbar = components == null ? void 0 : components.Toolbar;
  if (view == null) {
    return null;
  }
  return /*#__PURE__*/_jsxs(PickersViewLayoutRoot, {
    className: clsx(className, classes.root),
    ref: ref,
    children: [/*#__PURE__*/_jsxs(PickersViewLayoutContent, {
      className: classes.content,
      children: [shouldRenderToolbar && !!Toolbar && /*#__PURE__*/_jsx(Toolbar, _extends({}, componentsProps == null ? void 0 : componentsProps.toolbar, {
        isLandscape: isLandscape,
        onChange: onChange,
        value: value,
        view: view,
        onViewChange: onViewChange,
        views: views,
        disabled: disabled,
        readOnly: readOnly
      })), !!Tabs && /*#__PURE__*/_jsx(Tabs, _extends({
        view: view,
        onViewChange: onViewChange
      }, componentsProps == null ? void 0 : componentsProps.tabs)), children]
    }), /*#__PURE__*/_jsx(ActionBar, _extends({}, actionBarProps))]
  });
});